import { joinPath } from './joinPath';

export const absoluteUrlClient = (path?: string): string => joinPath(window.location.origin, path);
